export default function getBrowserLocale() {
  const browserLanguage = navigator.language.toLowerCase()
  if (['es', 'de', 'fr'].some(lang => browserLanguage.includes(lang)))
    return browserLanguage.split('-')[0]
  return browserLanguage
}
